import { AxiosPromise } from "axios";

// NPM PACKAGES
import Http from "../../../utils/restClient";

type GetProductsListPayload = {
	page: number;
	pageSize?: number;
	search?: string;
	category?: string;
};

export default class ProductsApi {
	public static GetProductsList(payload: GetProductsListPayload) {
		const pageSize = payload.pageSize ?? 10;
		const search = encodeURIComponent(payload.search ?? "");
		const category = encodeURIComponent(payload.category ?? "");

		return Http.axios().get(
			`/api/v1/products?pageNumber=${payload.page}&pageSize=${pageSize}&search=${search}&category=${category}&isEventTicket=true`
		) as AxiosPromise<any>;
	}

	public static GetProductsBarCode(barCode) {
		return Http.axios().get(`/api/v1/products/barCode/${barCode}`);
	}

	public static SyncFavorites(productIds: number[]) {
		return Http.axios().post("/api/v1/products/favorites/sync", { productIds });
	}
}
